import React from 'react';
import { Tooltip } from 'primereact/tooltip';

interface TableColumnLongTextWithInformationProps {
  text: string | null;
  uniqueId: string | number;
  maxLength?: number;
}

export const TableColumnLongTextWithInformation: React.FC<
  TableColumnLongTextWithInformationProps
> = ({ text, uniqueId, maxLength = 20 }) => {
  const notes = text || '';
  const truncatedNotes =
    notes.length > maxLength ? notes.substring(0, maxLength) + '...' : notes;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
      }}
    >
      <span>{truncatedNotes}</span>
      {notes && (
        <>
          <Tooltip target={`.text-info-icon-${uniqueId}`} position="top" />
          <i
            className={`pi pi-info-circle text-info-icon-${uniqueId}`}
            data-pr-tooltip={notes}
            style={{
              cursor: 'pointer',
              color: '#6366F1',
              fontSize: '1rem',
            }}
          />
        </>
      )}
    </div>
  );
};
